/**
 * User Management - Supervisor Split and Assign Interfaces
 */

export interface UserRole {
  id: number;
  role_name: string;
  parent_role_id: number;
  role_full_name: string;
  role_type: number;
  status: number;
  program_id: number;
  created_date: string;
  updated_date: string;
  parent_role_name: string;
  // Backward compatibility aliases
  role_id?: number; // Same as id
  value?: string; // Same as role_name
  role_short_name?: string; // Same as role_name
}

export interface SupervisorSplitAssignPayload {
  program_id: number;
  role_id: number;
  excel_data: any[];
}

export interface SupervisorSplitAssignApiResponse {
  message: string;
  success: boolean;
  data?: any;
}
